<template>
    <div class="row-wrap" id="banner">
        <p><strong>Taken this class before?</strong> Earn $1 for every course review!</p>
        <a id="rating-button" target="_blank" :href="link">
            <div>
                <img src="@/assets/icons/actions/add-icon.svg" />
                <span>Add rating</span>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "AddRatingBanner",
    props: {
        id: String,
    },
    computed: {
        link() {
            return "#/rate/" + this.id;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_main.scss";

#banner {
    height: fit-content;
    justify-content: space-between;
    align-items: center;
    background: #fcf0ef;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 36px;
}

p {
    line-height: auto;
}

#rating-button {
    text-decoration: none;

    span {
        margin-left: 10px;
    }
    div {
        display: flex;
        flex-direction: row;
        flex: auto 10px auto;
        align-items: center;
        background: $primary;
        border-radius: 12px;
        width: fit-content;
        padding: 12px;
        color: white;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    #banner {
        justify-content: center;
    }
}

@media only screen and (max-width: $breakpoint-small) {
    #rating-button {
        width: 100%;

        div {
            justify-content: center;
            width: auto;
        }
    }
}
</style>
